// extracted by css-extract-rspack-plugin
export default {"backButton":"BackButton_backButton__GEVE3"};